import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants'
import * as ngswal from "sweetalert";
import { OsaStaffPortalModel } from './osa-staff-portal-model';

declare var $;

@Component({
  selector: 'app-osa-staff-portal',
  templateUrl: './osa-staff-portal.component.html',
  styleUrls: ['./osa-staff-portal.component.css']
})
/** osa-staff-portal component*/
export class OsaStaffPortalComponent {
  showModal: boolean;
  title: string;
  modelItem = new OsaStaffPortalModel();
  @ViewChild('dataTable', { static: false }) table;
  public aMenuList = [];
  dataTable: any;
  dtOptions: any;
  dataSet: any;

  /** osa-staff-portal ctor */
  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <OsaStaffPortalModel>data["OsaStaffPortal"];
        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
        this.LoadDataList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  ngOnInit() {
    $('#page-header-search-dropdown').hide();
    ApiMethod.getBaseUrl();
  }

  LoadDataList() {
    $("#LoadingImage").show();
    var fromDate = $('#Txt_FromDate').val();
    var toDate = $('#Txt_ToDate').val();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString()
    };
    ApiMethod.postMethod(this.modelItem.GetArticleTrackingList, paramData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.DataList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.ColList;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 180);
        dataItem.modulename = 'ArticleTracking';
        dataItem.infoPopupID = 'SNo';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  ResetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    this.LoadDataList();
  }

  hide() {
    this.showModal = false;
  }
  //Show Article Starter XML control popup
  showInfoPopUp(): void {
    $('#divStartXML').html('');
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.GetStarterXMLData + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.StarterXml;
          $('#divStartXML').html(itemL);
          this.showModal = true; // Show-Hide Modal Check
          this.title = "Article Viewer";    // Dynamic Data
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }

  }

}
